<template>
  <md-dialog :md-active.sync="showModal" class="modal-cuenta-nueva custom-dialog">
    <md-dialog-title class="dialog-header">
      <span class="header-title">{{ labels.titulo }}</span>
    </md-dialog-title>
    
    <md-dialog-content class="dialog-content">
      <div v-if="errorMessage" class="error-alert">
        <span class="error-icon">!</span>
        {{ errorMessage }}
      </div>
      
      <div class="form-fields">
        <div class="form-field">
          <label class="field-label">{{ labels.cuenta }}</label>
          <md-field class="custom-field">
            <md-input v-model="cuentaNueva.cuenta" required :disabled="loading" />
          </md-field>
        </div>
        
        <div class="form-field">
          <label class="field-label">{{ labels.descripcion }}</label>
          <md-field class="custom-field">
            <md-input v-model="cuentaNueva.descripcion" required :disabled="loading" />
          </md-field>
        </div>
      </div>
    </md-dialog-content>

    <md-dialog-actions class="dialog-actions">
      <md-button class="md-raised cancel-btn" @click="cancelar" :disabled="loading">
        {{ labels.cancelar }}
      </md-button>
      <md-button 
        class="md-raised md-primary save-btn" 
        @click="guardarCuenta" 
        :disabled="!formValido || loading"
      >
        {{ loading ? labels.guardando : labels.guardar }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import AjustesConsol from '../../services/AjustesConsol'

export default {
  name: 'ModalCuentaNuevaVue',
  props: {
    showModal: Boolean,
    idCompania: Number,
    codReporte: Number,
    vigencia: String,
    secuencia: Number,
    tipo_ajuste: Number,
    tipo: String
  },
  data() {
    return {
      cuentaNueva: {
        cuenta: '',
        descripcion: ''
      },
      loading: false,
      errorMessage: ''
    }
  },
  computed: {
    labels() {
      if(this.$store.state._language == "es-ES") {
        return {
          titulo: 'Crear Cuenta Nueva',
          cuenta: 'Número de Cuenta',
          descripcion: 'Descripción',
          cancelar: 'Cancelar',
          guardar: 'Guardar',
          guardando: 'Guardando...'
        }
      } else {
        return {
          titulo: 'Create New Account',
          cuenta: 'Account Number',
          descripcion: 'Description',
          cancelar: 'Cancel',
          guardar: 'Save',
          guardando: 'Saving...'
        }
      }
    },
    formValido() {
      return this.cuentaNueva.cuenta && 
             this.cuentaNueva.descripcion
    }
  },
  methods: {
    cancelar() {
      this.$emit('closeModal', false)
    },
    async guardarCuenta() {
      this.loading = true
      this.errorMessage = ''

      try {
        const datos = {
          vigencia: this.vigencia,
          companyId: this.idCompania,
          idUser: this.$store.state.id_user || 1,
          codReporte: this.codReporte,
          tipo_ajuste: this.tipo_ajuste || 2,
          secuencia: this.secuencia,
          cuenta: this.cuentaNueva.cuenta,
          descripcion: this.cuentaNueva.descripcion,
          saldo_actual: 0,
          id_compania: this.idCompania,
          tipo: this.tipo 
        }

        console.log('Datos para crear cuenta nueva:', datos);
        console.log('Valor de tipo enviado:', datos.tipo);

        await AjustesConsol.crearCuentaNueva(datos)

        this.$emit('cuentaCreada')
        this.limpiarFormulario()
        this.$emit('closeModal', true)
      } catch (error) {
        console.error('Error al crear cuenta:', error)
        this.errorMessage = error.response?.data?.message || 'Error al crear la cuenta'
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    showModal(val) {
      if (!val) {
        this.limpiarFormulario()
        this.errorMessage = ''
      }
    }
  }
}
</script>

<style scoped>
.custom-dialog {
  min-width: 450px;
  border-radius: 8px;
}

.dialog-header {
  background: #34495e;
  color: white;
  padding: 20px 24px;
  border-bottom: 1px solid #2c3e50;
}

.header-title {
  font-size: 1.2rem;
  font-weight: 500;
}

.dialog-content {
  padding: 24px;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-field {
  margin-bottom: 0;
}

.field-label {
  display: block;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 14px;
}

.custom-field {
  margin: 0;
}

.error-alert {
  background: #e74c3c;
  color: white;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.error-icon {
  background: white;
  color: #e74c3c;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 10px;
}

.dialog-actions {
  padding: 16px 24px;
  border-top: 1px solid #ecf0f1;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn {
  background: #95a5a6 !important;
  color: white !important;
}

.save-btn {
  background: #3498db !important;
  color: white !important;
}
</style>